import Create from "./Create";
import Edit from "./Edit";

export default {
  Create,
  Edit,
};
